import _         from 'lodash'
import Immutable from 'immutable';
import GroupMenu from './group_menu';

export default class DailyMenu {
  constructor(canteen, date, _groupMenus, _menu) {
    this.canteen     = canteen;
    this.date        = date;
    this._menu       = _menu;
    this._groupMenus = _groupMenus;
  }

  groupMenus() {
    return this._groupMenus?.map(this._groupMenuFor.bind(this)).valueSeq() ?? new Immutable.Seq;
  }

  groupNames() {
    return this._groupMenus?.keySeq() ?? new Immutable.Seq;
  }

  hasMeals() {
    return !_.isNil(this._groupMenus);
  }

  _groupMenuFor(courseMenus, groupName) {
    const group = this._menu.groups.find(groupName);

    return new GroupMenu(this.canteen, this.date, group, courseMenus, this._menu);
  }
}
